import { twMerge } from 'tailwind-merge';

import type { CustomThemeType } from './default';
import { defaultTheme } from './default';

const { button, checkbox, radio, text } = defaultTheme;

export const stagWorksTheme: CustomThemeType = {
  ...defaultTheme,

  checkbox: {
    ...checkbox,
    base: twMerge(checkbox.base, `border-c-border`),
    active: twMerge(checkbox.active, `focus:ring-primary focus:ring-1`),
    disabled: twMerge(checkbox.disabled, `dark:disabled:bg-gray-700`),
  },
  radio: { ...radio, active: twMerge(radio.active, `focus:ring-primary focus:ring-1`) },

  button: {
    ...button,
    active: twMerge(button.active, `focus:ring-0`),
    disabled: twMerge(button.disabled, 'dark:disabled:bg-gray-700'),
    link: {
      ...button.link,
      base: twMerge(button.active, `dark:text-gray-400`),
      active: twMerge(
        button.active,
        `hover:text-accent dark:hover:text-accent-x-light hover:bg-gray-50 dark:hover:bg-gray-900`
      ),
    },
    themeColor: {
      ...button.themeColor,
      dark: {
        ...button.themeColor.dark,
        link: twMerge(button.themeColor.dark.link, 'dark:text-gray-400'),
      },
    },
  },

  text: {
    ...text,
    h3: twMerge(text.h3, `font-sans`),
    h4: twMerge(text.h4, `font-sans`),
    h5: twMerge(text.h5, `font-sans`),
    h6: twMerge(text.h6, `font-sans`),
  },
};
